import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.29199 7.29166V3.33332C7.29199 2.75803 7.75836 2.29166 8.33366 2.29166H16.667C17.2423 2.29166 17.7087 2.75803 17.7087 3.33332V11.6667C17.7087 12.242 17.2423 12.7083 16.667 12.7083H12.7087",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M3.33366 7.29166H11.667C12.2423 7.29166 12.7087 7.75803 12.7087 8.33332V16.6667C12.7087 17.242 12.2423 17.7083 11.667 17.7083H3.33366C2.75836 17.7083 2.29199 17.242 2.29199 16.6667V8.33332C2.29199 7.75803 2.75836 7.29166 3.33366 7.29166Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }